import { render, staticRenderFns } from "./pay-info.vue?vue&type=template&id=652a91a2&scoped=true&"
import script from "./pay-info.vue?vue&type=script&lang=js&"
export * from "./pay-info.vue?vue&type=script&lang=js&"
import style0 from "./pay-info.vue?vue&type=style&index=0&id=652a91a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a91a2",
  null
  
)

export default component.exports